<template>
  <div class="not-found">
    <h1>404</h1>
    <p>{{$t('message.404')}}</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.not-found {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  h1 {
    padding: 1em;
    font-family: "Luckiest Guy", cursive;
    color: $primary;
  }
}
</style>
